var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hello screen-spacing" },
    [
      _vm._m(0),
      _c("SelectVenue", {
        ref: "venueDropDown",
        staticClass: "mb-3",
        on: { updateVenue: _vm.updateVenue },
      }),
      _vm.venue_id != "" && _vm.venue_id != "0"
        ? _c("SelectBar", {
            ref: "barDropDown",
            staticClass: "mb-3",
            attrs: { venueId: _vm.venue_id, liveOrder: true },
            on: { updateBar: _vm.updateBar },
          })
        : _vm._e(),
      _vm.bar_id != "" && _vm.displayTotalCount
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
                "margin-top": "1rem",
              },
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-dark mb-2",
                  on: { click: _vm.cancelAllRemainingOrders },
                },
                [_vm._v("Cancel All Orders")]
              ),
              _c("div", [
                _c("strong", [
                  _vm._v(
                    " Showing " +
                      _vm._s(_vm.orders.length) +
                      " of " +
                      _vm._s(_vm.displayTotalCount) +
                      " total orders"
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.bar_id != ""
        ? _c(
            "div",
            {
              staticClass: "row header",
              staticStyle: { "background-color": "purple" },
            },
            [
              _c("div", { staticClass: "col-md-2" }, [
                _vm._v(_vm._s(_vm.getButtonHeader())),
              ]),
              _c("div", { staticClass: "col-md-3 d-none d-md-block" }, [
                _vm._v("Order_ID"),
              ]),
              _c("div", { staticClass: "col-md-1 d-none d-md-block" }, [
                _vm._v("# of items"),
              ]),
              _c("div", { staticClass: "col-md-3 d-none d-md-block" }, [
                _vm._v("Cost"),
              ]),
              _c("div", { staticClass: "col-md-3 d-none d-md-block" }, [
                _vm._v("Time of order"),
              ]),
            ]
          )
        : _vm._e(),
      _vm._l(_vm.orders, function (order, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "row py-2",
            class: { "contact-us": order.is_accepted == true },
          },
          [
            _c("div", { staticClass: "col-md-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn text-bg-dark me-2",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.openModal(order)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.getButtonText(order)))]
              ),
              order.is_accepted == true
                ? _c(
                    "button",
                    {
                      staticClass: "btn btnSubmit d-none d-md-block",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.completeOrder(order)
                        },
                      },
                    },
                    [_vm._v("Complete")]
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "col-md-3 d-none d-md-block" }, [
              _vm._v(_vm._s(order.readable_ID)),
            ]),
            _c("div", { staticClass: "col-md-1 d-none d-md-block" }, [
              _vm._v(_vm._s(_vm.numberofItems(order.item_list))),
            ]),
            _c("div", { staticClass: "col-md-3 d-none d-md-block" }, [
              _vm._v(_vm._s(_vm.toDollarAmount(order.total_cost))),
            ]),
            _c("div", { staticClass: "col-md-3 d-none d-md-block" }, [
              _vm._v(_vm._s(_vm.formatDate(order.createdAt))),
            ]),
          ]
        )
      }),
      _c(
        "div",
        {
          ref: "modal",
          staticClass: "modal fade",
          attrs: {
            id: "orderListModal",
            tabindex: "-1",
            "aria-labelledby": "orderList",
            "aria-hidden": "true",
          },
        },
        [
          _c("CheckoutOrder", {
            attrs: {
              order: _vm.currentOrder,
              bar_id: _vm.bar_id,
              tableName: _vm.currentTableName,
            },
            on: {
              completeOrder: _vm.completeOrder,
              acceptOrder: _vm.acceptOrder,
              acceptModifiedOrder: _vm.acceptModifiedOrder,
              cancelOrder: _vm.cancelOrder,
              declineOrder: _vm.declineOrder,
              pingOrder: _vm.pingOrder,
            },
          }),
        ],
        1
      ),
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          ref: "action",
          attrs: {
            type: "button",
            "data-bs-toggle": "modal",
            "data-bs-target": "#orderListModal",
          },
        },
        [_c("i", { staticClass: "fa-solid fa-plus" })]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", {}, [
      _c("div", { staticClass: "h1 display-inline" }, [
        _vm._v("Current Order"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }